const MuiStack = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { useFlexGap: true },
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {},
};

export const stack = { MuiStack };
